import React, { useEffect } from "react";
import DisplayField from "./DisplayField";
import { config } from "../../../style";
import ActivityCard from "./ActivityCard";
import FlightIcon from "@mui/icons-material/Flight";
import DisplayTextBox from "./DisplayTextBox";
import { Button } from "@mui/material";
import DirectionsIcon from "@mui/icons-material/Directions";
import { post } from "../../../api";

function PrivateFlightCard({ item = {}, prepareDocumentData }) {
    const [flightStatusDetails, setFlightStatusDetails] = React.useState({});
    const [carrierURL, setCarrierURL] = React.useState("");
    const dataRef = React.useRef(null);
    useEffect(() => {
        if (item?.flightNumber && item.carrierCode) {
            const body = {
                carrier: item.carrierCode,
                flight: item.flightNumber,
                year: getDate(item.departureStart).year,
                month: getDate(item.departureStart).month,
                day: getDate(item.departureStart).day,
            };

            post("custom/getFlightDetails", body)
                .then((response) => {
                    // if (response?.data?.flightStatus) {
                    //     item.flightStatus = response.data.flightStatus;
                    // }
                    if (response.isSuccess) {
                        setFlightStatusDetails(response.data);
                    }
                    console.log(response?.data);
                })
                .catch((error) => {
                    console.error("Error fetching flight status:", error);
                });
        }

        if (item.carrierCode) {
            const body = {
                carrier: item.carrierCode,
            };
            post("custom/getCarrierURL", body)
                .then((response) => {
                    if (response.isSuccess) {
                        setCarrierURL(response.data);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching flight status:", error);
                });
        }
    }, [item]);
    const getAirlineURL = (item) => {
        let dateData = getDate(item.departureStartString);
        if (!item.flightNumber) {
            return "";
        }

        return `https://www.flightstats.com/v2/flight-tracker/${item.carrierCode}/${item.flightNumber}?year=${dateData.year}&month=${dateData.month}&date=${dateData.day}`;
    };

    useEffect(() => {
        dataRef.current = dataRef.current || {};
        if (getAirlineURL(item)) {
            dataRef.current["Track Flight"] = { value: getAirlineURL(item), type: "button", side: "right", order: 10 };
        }

        prepareDocumentData(item.id, dataRef.current);
    }, [item, carrierURL, flightStatusDetails]);

    const getDate = (dateStr) => {
        const [datePart] = dateStr.split("T"); // "2024-04-04"
        const [year, month, day] = datePart.split("-");

        return { year, month, day };
    };

    const minutesToHHMM = (totalMinutes) => {
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        // Pad with leading zeros if needed
        const formattedHours = String(hours).padStart(2, "0");
        const formattedMinutes = String(minutes).padStart(2, "0");

        return `${formattedHours}:${formattedMinutes}`;
    };

    const prepareLeftData = (key, value, order, mainText) => {
        dataRef.current = dataRef.current || {};
        if (mainText) {
            value.value = mainText;
        }
        dataRef.current[key] = { ...value, side: "left", order };
    };
    const prepareRightData = (key, value, order, mainText) => {
        dataRef.current = dataRef.current || {};
        if (mainText) {
            value.value = mainText;
        }
        dataRef.current[key] = { ...value, side: "right", order };
    };
    return (
        <ActivityCard
            label="Private Flight"
            icon={<FlightIcon fontSize="small" sx={{ color: config.primaryColor }}></FlightIcon>}
            subject={item.subject}
            // date={item.departureStartTimeString}
            timezone={item.departureTimeZoneCode}
            detail={
                <>
                    {item.departureStartTimeString && (
                        <DisplayField
                            label="Departure"
                            type="LocationTime"
                            date={item.departureStartTimeString}
                            timezone={item.departureTimeZoneCode}
                            location={`${item.departureAirportName ? item.departureAirportName : ""}`}
                            prepareData={(key, value) => prepareLeftData(key, value, 1)}></DisplayField>
                    )}
                    {item.arrivalEndTimeString && (
                        <DisplayField
                            label="Arrival"
                            type="LocationTime"
                            date={item.arrivalEndTimeString}
                            timezone={item.arrivalTimeZoneCode}
                            location={`${item.arrivalAirportName ? item.arrivalAirportName : ""}`}
                            prepareData={(key, value) => prepareLeftData(key, value, 2)}></DisplayField>
                    )}
                    {(item.duration || flightStatusDetails.flightDuration) && (
                        <DisplayField
                            label="Flight Duration"
                            type="Text"
                            text={`${
                                flightStatusDetails.flightDuration
                                    ? minutesToHHMM(flightStatusDetails.flightDuration)
                                    : item.duration
                            }`}
                            prepareData={(key, value) => prepareLeftData(key, value, 3)}></DisplayField>
                    )}
                    {item.carrierCode && (
                        <DisplayField
                            label="Carrier"
                            type="Text"
                            text={item.carrierCode}
                            prepareData={(key, value) => prepareLeftData(key, value, 4)}></DisplayField>
                    )}
                    {item.planeType && (
                        <DisplayField
                            label="Plane Type"
                            type="Text"
                            text={item.planeType}
                            prepareData={(key, value) => prepareLeftData(key, value, 5)}></DisplayField>
                    )}
                </>
            }
            rightElement={
                <>
                    {item.vendorName && (
                        <DisplayTextBox
                            title={"Vendor"}
                            value={item.vendorName}
                            prepareData={(key, value) => prepareRightData(key, value, 1)}
                        />
                    )}
                    {item.vendorPhone && (
                        <DisplayTextBox
                            title={"Phone Number"}
                            value={item.vendorPhone}
                            prepareData={(key, value) => prepareRightData(key, value, 2)}
                        />
                    )}
                    {item.pilot && (
                        <DisplayTextBox
                            title={"Pilot"}
                            value={item.pilot}
                            prepareData={(key, value) => prepareRightData(key, value, 3)}
                        />
                    )}
                    {item.arrangedBy && (
                        <DisplayTextBox
                            title={"Arranged By"}
                            value={item.arrangedBy}
                            prepareData={(key, value) => prepareRightData(key, value, 4)}
                        />
                    )}
                    {item.flightNumber && (
                        <DisplayTextBox
                            title={"Flight Number"}
                            value={
                                <>
                                    {item.carrierCode} {item.flightNumber}
                                </>
                            }
                            prepareData={(key, value) =>
                                prepareRightData(key, value, 5, `${item.carrierCode} ${item.flightNumber}`)
                            }
                        />
                    )}
                    {carrierURL && (
                        <DisplayTextBox
                            title={"Carrier Website"}
                            value={carrierURL}
                            type={"link"}
                            prepareData={(key, value) => prepareRightData(key, value, 6)}
                        />
                    )}
                    {flightStatusDetails.equipments && (
                        <DisplayTextBox
                            title={"Equipment"}
                            value={`${flightStatusDetails.equipments.iata} - ${flightStatusDetails.equipments.name}`}
                            prepareData={(key, value) => prepareRightData(key, value, 7)}
                        />
                    )}
                    {item.carrierCode && item.flightNumber && (
                        <Button
                            startIcon={<DirectionsIcon fontSize="small" />}
                            href={getAirlineURL(item)}
                            size="small"
                            target="_blank"
                            variant="outlined">
                            Track Flight
                        </Button>
                    )}
                </>
            }></ActivityCard>
    );
}

export default PrivateFlightCard;
